import React from "react";
import "./ToolBarLeftPanel.scss";
import checkMarkGreen from "../../images/CheckmarkGreen.svg";
import expandIcon from '../../images/right_arrow.svg';
const BuisnessRuleCard = ({ cardObj,handleExpandModuleClaims,setSelectedModule }) => {

  // if (cardObj.targetModuleMlrStatus !== "Available for Use") {
  //   return null;
  // }
  
  return (
    <div className="selected-module-cards associated-card " onClick={() => {
                  setSelectedModule(cardObj,"childModule");
                  handleExpandModuleClaims(cardObj,"childModule");
                }}>
     
      <div className="moduleCardFirstRow">
       
        <div className="cardInfoLeftSide">
        
          <img src={checkMarkGreen} className="checkMarkClass" />
          <strong className="boldText">{cardObj?.targetModuleDamName}</strong>
        </div>
        <div className="cardInfoRightSide">      
           <div className={cardObj?.ruleCondition==="Optional" ? "optional-box" : "mustuse-box"}></div>
           <div className="parentModuleText">{cardObj?.ruleCondition==="Optional" ? "Optional" : "Must Use"}</div>{" "}
          <img src={expandIcon} className="expandIcon-module" />
        </div>
      </div>
      <div className="moduleCardsRow">
      <div className="infoText">Product :</div>
            {/* <div className="colonClass">:</div> */}
            <span className="nameBrandText">{""}{cardObj?.productName}</span>
      </div>
      <div className="moduleCardsRow">
      
      <div className="infoText">Name : </div>
            {/* <div className="colonClass">:</div> */}
            <span className="nameBrandText">{""}{cardObj?.targetModuleName}</span>
      </div>
    </div>
  );
};
export default BuisnessRuleCard;
